import React from 'react';

import { LoadablePaint } from '@confluence/loadable';
import { ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';

const AdminForgeAppsRedirect = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-AdminForgeAppsRedirect" */ '@confluence/forge-ui/entry-points/AdminForgeAppsRedirect.ts'
			)
		).AdminForgeAppsRedirect,
});

export const AdminForgeAppsRedirectRoute = ({ params, query }) => {
	return <AdminForgeAppsRedirect params={params} query={query} />;
};

AdminForgeAppsRedirectRoute.NAVIGATION_PARAMS = () => ({
	Screen: {
		screenEvent: {
			name: 'adminForgeAppsRedirect',
		},
	},
	MainLayout: {
		navView: ADMIN_HOME_ID,
	},
});
